import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import SupportIcon from "@mui/icons-material/Support";
import {
  Breadcrumbs,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Link,
  Slide,
  Typography,
} from "@mui/material";
import parse from "html-react-parser";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { getUserMenuList } from "../../../../application/selectors/user";
import { onCheckIsShowMainMenu } from "../../../middleware/middleware";

function LinkRouter(props) {
  return <Link {...props} component={RouterLink} />;
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BreadcrumbsComponent = () => {
  const location = useLocation();
  const menuList = useSelector(getUserMenuList);

  const [breadcrumbNameMap, setBreadcrumbNameMap] = useState({});
  const [userGuideModal, setUserGuideModal] = useState(false);
  const [menuItem, setMenuItem] = useState({});
  const [isShowMainMenu, setIsShowMainMenu] = useState(true);
  const pathnames = location.pathname.split("/").filter((x) => x);

  const handleOpen = () => setUserGuideModal(true);
  const handleClose = () => setUserGuideModal(false);

  useEffect(() => {
    setIsShowMainMenu(onCheckIsShowMainMenu());
  }, []);

  const onMakeBreadcrumbData = (items) => {
    let data = {};
    items.forEach((menu) => {
      if (menu.level !== 2 || (menu.level === 2 && menu.oldLink)) {
        data[`${menu.link}`] = menu.title;
      }

      if (menu.link === location.pathname) {
        // console.log("menu", menu);
        setMenuItem(menu);
      }
      if (Array.isArray(menu.child)) {
        data = { ...data, ...onMakeBreadcrumbData(menu.child) };
      }
    });
    return data;
  };

  useEffect(() => {
    if (Array.isArray(menuList) && menuList.length > 0) {
      const breadcrumbs = onMakeBreadcrumbData(menuList);
      setBreadcrumbNameMap(breadcrumbs);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuList]);

  return (
    <Grid container>
      <Grid item xs={12} md={10}>
        <Breadcrumbs
          aria-label="breadcrumb"
          separator={<NavigateBeforeIcon fontSize="small" />}
        >
          {isShowMainMenu ? (
            <LinkRouter underline="hover" color="inherit" to="/">
              داشبورد
            </LinkRouter>
          ) : null}

          {pathnames.map((value, index) => {
            const last = index === pathnames.length - 1;
            const to = `/${pathnames.slice(0, index + 1).join("/")}`;

            return last ? (
              <Typography color="text.primary" key={to}>
                {breadcrumbNameMap[to]
                  ? breadcrumbNameMap[to]
                  : value === "Information"
                  ? "بررسی اطلاعات"
                  : "ایجاد یا ویرایش"}
              </Typography>
            ) : isShowMainMenu || index !== 0 ? (
              <LinkRouter underline="hover" color="inherit" to={to} key={to}>
                {breadcrumbNameMap[to]}
              </LinkRouter>
            ) : null;
          })}
        </Breadcrumbs>
      </Grid>

      {menuItem.guid ? (
        <Grid
          item
          container
          xs={12}
          md={2}
          alignItems="center"
          justifyContent="end"
        >
          <Button onClick={handleOpen} color="info" startIcon={<SupportIcon />}>
            راهنمای کاربر
          </Button>

          <Dialog
            open={userGuideModal}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="user-guide-dialog"
            maxWidth={"md"}
            fullWidth={true}
            scroll={"body"}
          >
            <DialogTitle>راهنمای کاربر</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {menuItem?.description
                  ? parse(menuItem.description)
                  : "راهنمای کاربر موجود نیست"}
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default BreadcrumbsComponent;
